// extracted by mini-css-extract-plugin
export default {"clients__list":"ClientSlider_clients__list__suZ9c","slider__item":"ClientSlider_slider__item__4R-UC","sponsor__logo":"ClientSlider_sponsor__logo__abiwq"};